<template>

  <div>

    <v-dialog v-model="show_dialog_ref" max-width="70%">


      <v-card>
        <v-card-title>
          What is Cancer
        </v-card-title>
        <v-card-text>


          <p>
            The U.S. Preventive Services Task Force recommends those 50 - 75 undergo regular screening.
            Note, however, that the American Cancer Society recently changed their recommended guidelines to include
            those 45 and above.
          </p>




          Source: US Centers for Disease Control and Prevention (CDC)<br>
          <a href="https://www.cdc.gov/cancer/colorectal/basic_info/screening/index.htm"
             target="_blank">
            https://www.cdc.gov/cancer/colorectal/basic_info/screening/index.htm
          </a>

          <br>
          Source: American Cancer Society <br>
          <a href="https://www.cancer.org/cancer/colon-rectal-cancer/detection-diagnosis-staging/acs-recommendations.html"
             target="_blank">
            https://www.cancer.org/cancer/colon-rectal-cancer/detection-diagnosis-staging/acs-recommendations.html
          </a>

        </v-card-text>

      </v-card>


    </v-dialog>












    <v-card max-width="900px">
      <v-card-title >
        Nausea and Vomiting
      </v-card-title>
      <v-card-text  class="content-text my-content">

        <div class="title">
          What Is It
        </div>

        <p>
          Vomiting is when the contents of your stomach are forced back up your esophagus and come back out of your mouth.
          Nausea is the sensation that you will vomit.
        </p>


        <div class="title">
          Causes
        </div>

        <p>The most common cause of nausea and vomiting is eating something that makes you sick, e.g. food poisoning.
          However, there are many reason why you might vomit including</p>

        <ul>
          <li>Stomach ulcer</li>
          <li>Duodenal ulcer</li>
          <li>Gall bladder disease such as gall stones</li>
          <li>Stomach flu</li>
          <li>Cancer of stomach or pancreas, liver, or colon</li>
          <li>Bowel obstruction</li>
          <li>Appendicitis</li>
          <li>Heart attack</li>
          <li>Brain tumor</li>

        </ul>


        <div class="title">
          Treatments
        </div>

        <p>
         In most cases nausea and vomiting will go away by itself.  If it persists, try the following.
        </p>

        <ul>
          <li>Eat small meals and eat slowly</li>
          <li>Drink water with a pinch of salt</li>
          <li>Room temperature foods and liquids are better than hot or cold temperatures</li>
          <li>Rest after eating with your head 12 inches above the floor</li>
          <li>Drink liquids between meals, as opposed to with your meals</li>
        </ul>



        <div class="title">
          When To Call A Doctor
        </div>


        <p>
          Here's when you should see a doctor.
        </p>

        <ul>
          <li>The above treatments aren't working</li>
          <li>You are severely dehydrated (dry and sunken skin)</li>
          <li>Blood in vomit (bright red blood or coffee grounds materials)</li>
          <li>Severe headache and stiff neck</li>
          <li>Lethargy, mental confusion, and/or decreased alertness</li>
          <li>Rapid breathing</li>
          <li>Rapid pulse</li>
        </ul>

        <div class="title" v-if="bib != null">
          References
        </div>
        <refs  :refs="bib"></refs>
      </v-card-text>

    </v-card>
  </div>




</template>





<style scoped lang="scss">
  @use 'contentStyles';

</style>


<script>
// @ is an alias to /src
import refs from '@/components/references.vue';
import utilities from '@/mixins/utilities.js';


export default {
   mixins: [utilities],
   components: {refs},
   data(){return {

      show_dialog_ref: false,
      bib: null,
   }},



   methods:{
      getr(ref){
         return (this.findWithAttr(this.bib, 'ref', ref)+1).toString();
      }
   },

   created(){

      this.sort_bib_list(this.bib);
   }



}
</script>
